import React from "react";
import { useSelector } from "react-redux";
import { HeaderTitle } from "./HeaderTitle";
import { Search } from "../Search";
import { shortenName } from "../../assets/utils/functions";
import avatar from "../../assets/images/none.jpg";

import eyeIcon from "./../../assets/images/headerIcons/Eye.svg";
import bellIcon from "./../../assets/images/headerIcons/Bell.svg";
// import avatarIcon from './../../assets/images/headerIcons/img-human.svg';
// import avatarIcon from "./../../assets/images/vector.svg";
import "./style.css";
import { MenuButton } from "../MenuButton";

export const Header = ({ userRole }) => {
  const userInfo = useSelector((state) => state.auth.userInfo);
  const userPhoto = useSelector(
    (state) => state.student?.studentInfo?.photoUrl
  );

  return (
    <header className="header">
      <div className="header-block">
        <div className="header-block_userInfo">
          <img
            className="header-user_img"
            src={userPhoto ? `https://student.vstu.by${userPhoto}` : avatar}
            alt="Avatar icon"
          />
          <div className="header-user_info">
            {userInfo !== null ? (
              <>
                <p>{shortenName(userInfo.fio)}</p>
                <p className="header-email">{userInfo.email}</p>
              </>
            ) : (
              <></>
            )}
          </div>
        </div>
        <MenuButton userRole={userRole} />
      </div>
    </header>
  );
};
